import { Point } from "highcharts";
import { ProcessedHistoryData } from "@/store/budgets/selectors/details-drawer/budgetDetailsHistoryProcessedDataSelector";
import { money } from "@/utils/numeral/money";

export const getBudgetDetailsHistoryChartTooltipValueGetter = (
  processedData?: ProcessedHistoryData[],
) => {
  return (point: Point) => {
    const date = point?.category;
    const index = point?.index ?? 0;
    const data = processedData?.at(index);

    const noCollectedData = typeof data?.used === "string";

    return `
      <div style="min-width: 210px">
        <div style="font-size: 13px; color: #666; margin-bottom: 8px">
            ${date}
        </div>  
        
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px">
          <span
            style="
              display: flex;
              align-items: center;
              font-size: 11px;
              margin-right: 16px;
            "
          >
            <span
              style="font-weight: 400; font-size: 12px; word-break: break-word; white-space: normal; color: #000"
            >
              Used
            </span>
          </span>
          
          <div
            style="display: flex; flex-direction: row; align-items: center"
          >
            <span style="font-weight: 500; font-size: 12px; margin-right: 4px">
              ${noCollectedData ? data?.used : money(data?.used)}
            </span>
          </div>
        </div>
        
        <div style="display: flex; justify-content: space-between; align-items: center">
          <span
            style="
              display: flex;
              align-items: center;
              font-size: 11px;
              margin-right: 16px;
            "
          >
            <span
              style="font-weight: 400; font-size: 12px; word-break: break-word; white-space: normal; color: #000"
            >
              Budget
            </span>
          </span>
          
          <div
            style="display: flex; flex-direction: row; align-items: center"
          >
            <span style="font-weight: 500; font-size: 12px; margin-right: 4px">
              ${money(data?.budget)}
            </span>
          </div>
        </div>
        
        ${noCollectedData ? messageHTML : ""}
    `;
  };
};

const messageHTML = `
<div style="display: flex; align-items: flex-start; width: 208px; border: 1px solid #2196F3; border-radius: 6px; padding: 6px; gap: 4px; background-color: #F5FAFF; opacity: 1; font-family: Arial, sans-serif; margin-top: 8px">
  <!-- Info Icon -->
  <div style="flex-shrink: 0; margin-top: 2px;">
    <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.33398 3.66634H7.66732V4.99967H6.33398V3.66634ZM6.33398 6.33301H7.66732V10.333H6.33398V6.33301ZM7.00065 0.333008C3.32065 0.333008 0.333984 3.31967 0.333984 6.99967C0.333984 10.6797 3.32065 13.6663 7.00065 13.6663C10.6807 13.6663 13.6673 10.6797 13.6673 6.99967C13.6673 3.31967 10.6807 0.333008 7.00065 0.333008ZM7.00065 12.333C4.06065 12.333 1.66732 9.93967 1.66732 6.99967C1.66732 4.05967 4.06065 1.66634 7.00065 1.66634C9.94065 1.66634 12.334 4.05967 12.334 6.99967C12.334 9.93967 9.94065 12.333 7.00065 12.333Z" fill="#2196F3"/>
    </svg>
  </div>

  <!-- Message -->
  <div style="color: #0D355C; font-size: 10px; line-height: 1.3; text-align: left; white-space: normal; word-break: break-word; margin-left: 2px">
    The latest billing data is not yet available as it’s still being processed by your cloud provider
  </div>
</div>
`;
